import React from 'react'
import useContractDragons from '../../../hooks/useContractDragons'
import ContractStatisticWidget from '../ContractStatisticWidget'

export default function TotalDragons() {

  const { totalDragons, isLoading: totalDragonsLoading } = useContractDragons()

  return (
    <ContractStatisticWidget
      isLoading={totalDragonsLoading}
      title="Total Dragons "
      value={totalDragons}
      decimals={0}
      thousandSeparator={true}
      suffix=""
    />
  )
}
